export default __webpack_public_path__ + "static/media/Blue_Vector.eeed659e.svg";